import { ClientPlanType } from '../enum/client-plan-type.enum';
import { PlanType } from '../enum/planType.enum';
import { Plan } from '../models/client/client.model';
import { Comment } from '../models/comment/comment.model';
import {
  CommonSelectorV2,
  CommonSelectorV3,
  CommonSelectorV4,
} from '../models/common/common.model';
import { TransferType } from '../models/common/transfer-type.model';
import {
  Selector,
  VehicleChassisType,
} from '../models/selector/selector.model';
import { VehicleFuelType } from '../models/vehicle-fuel-type/vehicle-fuel-type.model';
import {
  VerticalType,
  VerticalTypeTwo,
} from '../models/vertical-type/vertical-type.model';

export const cancel_types: Selector[] = [
  {
    value: 0,
    text: 'Cancelación Interna 0%',
  },
  {
    value: 1,
    text: 'Cancelación Cliente 0%',
  },
  {
    value: 2,
    text: 'Cancelación Cliente 50%',
  },
  {
    value: 3,
    text: 'Cancelación Cliente 100%',
  },
];

export const vehicleChasisType: VehicleChassisType[] = [
  {
    value: 1,
    name: 'SEDAN',
    real_name: 'Turismo',
  },
  {
    value: 2,
    name: 'MINIVAN',
    real_name: 'Monovolumen',
  },
  {
    value: 3,
    name: 'ATV',
    real_name: 'Todoterreno',
  },
  {
    value: 4,
    name: 'LIGHT_VAN',
    real_name: 'Furgoneta ligera',
  },
  {
    value: 5,
    name: 'VAN',
    real_name: 'Furgoneta',
  },
  {
    value: 6,
    name: 'BOX_TRUCK',
    real_name: 'Furgón',
  },
  {
    value: 20,
    name: 'SCOOTER',
    real_name: 'Moto (hasta 125cc)',
  },
  {
    value: 21,
    name: 'MOTORBIKE',
    real_name: 'Moto +125cc',
  },
];

export const vehicleChasisTypeWithTranslations: VehicleChassisType[] = [
  {
    value: 1,
    name: 'SEDAN',
    real_name: 'common.vehicleChassis.SEDAN',
  },
  {
    value: 2,
    name: 'MINIVAN',
    real_name: 'common.vehicleChassis.MINIVAN',
  },
  {
    value: 3,
    name: 'ATV',
    real_name: 'common.vehicleChassis.ATV',
  },
  {
    value: 4,
    name: 'LIGHT_VAN',
    real_name: 'common.vehicleChassis.LIGHT_VAN',
  },
  {
    value: 5,
    name: 'VAN',
    real_name: 'common.vehicleChassis.VAN',
  },
  {
    value: 6,
    name: 'BOX_TRUCK',
    real_name: 'common.vehicleChassis.BOX_TRUCK',
  },
  {
    value: 20,
    name: 'SCOOTER',
    real_name: 'common.vehicleChassis.SCOOTER',
  },
  {
    value: 21,
    name: 'MOTORBIKE',
    real_name: 'common.vehicleChassis.MOTORBIKE',
  },
];

export const statusList = {
  INITIALIZED: 'INITIALIZED',
  PENDING: 'PENDING',
  CONFIRMED: 'CONFIRMED',
  PICKING_UP: 'PICKING_UP',
  IN_PROGRESS: 'IN_PROGRESS',
  DELIVERING: 'DELIVERING',
  FINISHED: 'FINISHED',
  FAILED: 'FAILED',
  CANCELLED_BY_CAFLER: 'CANCELLED_BY_CAFLER',
  CANCELLED_BY_CLIENT: 'CANCELLED_BY_CLIENT',
  CANCELLED: 'CANCELLED',
};

export type StatusKey = keyof typeof statusList;

export const verticalTypes: VerticalType[] = [
  { name: 'Transfer', type: 'TRANSFER' },
  { name: 'Taller', type: 'MECHANICAL_INSPECTION' },
  { name: 'Lavado', type: 'VEHICLE_WASH' },
  { name: 'Repostaje', type: 'REFUELING' },
  { name: 'Pre-ITV', type: 'PRE_TECHNICAL_INSPECTION' },
  { name: 'Transfer Larga Distancia', type: 'LONG_DISTANCE_TRANSFER' },
  { name: 'ITV', type: 'TECHNICAL_INSPECTION' },
  { name: 'Seguro', type: 'VEHICLE_INSURANCE' },
  { name: 'Cafler Fresh', type: 'ACCESSORY' },
  { name: 'Valet', type: 'VALET' },
  { name: 'Neumáticos', type: 'TYRES' },
  { name: 'Trámites', type: 'FORMALITIES' },
  { name: 'Parking', type: 'PARKING' },
  { name: 'Vehículo de sustitución', type: 'REPLACEMENT_VEHICLE' },
  { name: 'Grúa', type: 'TOW_TRUCK' },
  { name: 'Pide lo que quieras', type: 'WHATEVER_YOU_WANT' },
  { name: 'Campa', type: 'VEHICLE_STORAGE' },
  { name: 'Batería', type: 'BATTERY' },
];


export const verticalsTypes2: VerticalTypeTwo[] = [
  { value: 1, name: 'TRANSFER', realName: 'Transfer' },
  { value: 2, name: 'MECHANICAL_INSPECTION', realName: 'Taller' },
  { value: 3, name: 'VEHICLE_WASH', realName: 'Lavado' },
  { value: 4, name: 'REFUELING', realName: 'Repostaje' },
  { value: 5, name: 'PRE_TECHNICAL_INSPECTION', realName: 'Pre-ITV' },
  {
    value: 6,
    name: 'LONG_DISTANCE_TRANSFER',
    realName: 'Transfer Larga Distancia',
  },
  { value: 7, name: 'TECHNICAL_INSPECTION', realName: 'ITV' },
  { value: 8, name: 'VEHICLE_INSURANCE', realName: 'Seguro' },
  { value: 10, name: 'ACCESSORY', realName: 'Cafler Fresh' },
  { value: 11, name: 'VALET', realName: 'Valet' },
  { value: 12, name: 'TYRES', realName: 'Neumáticos' },
  { value: 13, name: 'FORMALITIES', realName: 'Trámites' },
  { value: 14, name: 'PARKING', realName: 'Parking' },
  {
    value: 15,
    name: 'REPLACEMENT_VEHICLE',
    realName: 'Vehículo de sustitución',
  },
  { value: 16, name: 'TOW_TRUCK', realName: 'Grúa' },
  { value: 17, name: 'WHATEVER_YOU_WANT', realName: 'Pide lo que quieras' },
  { value: 18, name: 'VEHICLE_STORAGE', realName: 'Campa' },
  { value: 19, name: 'BATTERY', realName: 'Batería' },
];

export const verticalTypes3: VerticalTypeTwo[] = [
  { value: 1, name: 'Transfer', realName: 'transfer' },
  {
    value: 2,
    name: 'MechanicalInspection',
    realName: 'mechanical_inspection',
  },
  { value: 3, name: 'VehicleWash', realName: 'vehicle_wash' },
  { value: 4, name: 'Refueling', realName: 'refueling' },
  {
    value: 5,
    name: 'PreTechnicalInspection',
    realName: 'pre_technical_inspection',
  },
  {
    value: 6,
    name: 'LongDistanceTransfer',
    realName: 'long_distance_transfer',
  },
  { value: 7, name: 'TechnicalInspection', realName: 'technical_inspection' },
  { value: 8, name: 'VehicleInsurance', realName: 'vehicle_insurance' },
  { value: 10, name: 'Accessory', realName: 'accessory' },
  { value: 11, name: 'Valet', realName: 'valet' },
  { value: 12, name: 'Tyres', realName: 'tyres' },
  { value: 13, name: 'Formalities', realName: 'formalities' },
  { value: 14, name: 'Parking', realName: 'parking' },
  { value: 15, name: 'ReplacementVehicle', realName: 'replacement_vehicle' },
  { value: 16, name: 'TowTruck', realName: 'tow_truck' },
  { value: 17, name: 'WhateverYouWant', realName: 'whatever_you_want' },
  { value: 18, name: 'VehicleStorage', realName: 'vehicle_storage' },
  { value: 19, name: 'Battery', realName: 'battery' },
];

export const comments: Comment[] = [
  {
    type: 'in',
    content:
      'Lorem ipsum dolor sit amet consectetur. Leo at auctor vivamus enim sed massa risus cras dolor. Tortor euismod est ultricies semper nisl nulla mollis. Viverra habitasse in pharetra in aliquet. Malesuada pretium mollis dignissim nunc nec.',
    footer_name: 'Javier garcia',
    footer_hour: '13:06',
    footer_date: '13/08/2024',
  },
  {
    type: 'co',
    content:
      'Lorem ipsum dolor sit amet consectetur. Leo at auctor vivamus enim sed massa risus cras dolor. Tortor euismod est ultricies semper nisl nulla mollis. Viverra habitasse in pharetra in aliquet. Malesuada pretium mollis dignissim nunc nec.',
    footer_name: '',
    footer_hour: '',
    footer_date: '',
  },
  {
    type: 'in',
    content:
      'Lorem ipsum dolor sit amet consectetur. Leo at auctor vivamus enim sed massa risus cras dolor. Tortor euismod est ultricies semper nisl nulla mollis. Viverra habitasse in pharetra in aliquet. Malesuada pretium mollis dignissim nunc nec.',
    footer_name: 'Javier garcia',
    footer_hour: '13:06',
    footer_date: '13/08/2024',
  },
];

export const vehicleFuelType: VehicleFuelType[] = [
  {
    value: 0,
    name: 'NA',
    real_name: 'Desconocido',
  },
  {
    value: 1,
    name: 'FUEL_95',
    real_name: 'Gasolina 95',
  },
  {
    value: 2,
    name: 'FUEL_98',
    real_name: 'Gasolina 98',
  },
  {
    value: 3,
    name: 'DIESEL',
    real_name: 'Diesel e+',
  },
  {
    value: 4,
    name: 'DIESEL_PREMIUM',
    real_name: 'Diesel 10e+',
  },
  {
    value: 5,
    name: 'HYBRID',
    real_name: 'Híbrido',
  },
  {
    value: 6,
    name: 'ELECTRIC',
    real_name: 'Eléctrico',
  },
  {
    value: 7,
    name: 'NATURAL_GAS',
    real_name: 'Gas',
  },
  {
    value: 8,
    name: 'FUEL_95E10',
    real_name: 'Gasolina 95 e10',
  },
  {
    value: 20,
    name: 'OTHER',
    real_name: 'Otro',
  },
];


export const vehicleFuelTypeTranslated: VehicleFuelType[] = [
  {
    value: 0,
    name: 'NA',
    real_name: 'na',
  },
  {
    value: 1,
    name: 'FUEL_95',
    real_name: 'fuel_95',
  },
  {
    value: 2,
    name: 'FUEL_98',
    real_name: 'fuel_98',
  },
  {
    value: 3,
    name: 'DIESEL',
    real_name: 'diesel',
  },
  {
    value: 4,
    name: 'DIESEL_PREMIUM',
    real_name: 'diesel_premium',
  },
  {
    value: 5,
    name: 'HYBRID',
    real_name: 'hybrid',
  },
  {
    value: 6,
    name: 'ELECTRIC',
    real_name: 'electric',
  },
  {
    value: 7,
    name: 'NATURAL_GAS',
    real_name: 'natural_gas',
  },
  {
    value: 8,
    name: 'FUEL_95E10',
    real_name: 'fuel_95e10',
  },
  {
    value: 20,
    name: 'OTHER',
    real_name: 'other',
  },
];

export const vehicleFuel: string[] = [
  'Gasolina 95',
  'Gasolina 98',
  'Diesel e+',
  'Diesel 10e+',
  'Híbrido',
  'Eléctrico',
  'Gas',
  'Gasolina 95 e10',
  'Otro',
];

export const vehicleFuelAlt: string[] = [
  'Gasolina 95',
  'Gasolina 98',
  'Diesel e+',
  'Diesel 10e+',
];

export const transferType: TransferType[] = [
  {
    value: 0,
    name: 'ON_ROAD',
  },
  {
    value: 1,
    name: 'INDIVIDUAL_TOW_TRUCK',
  },
  {
    value: 2,
    name: 'COLLECTIVE_TOW_TRUCK',
  },
];

export const vehicle_status: string[] = [
  'El vehículo arranca y puede rodar correctamente',
  'El vehículo no arranca pero puede rodar correctamente',
  'El vehículo no arranca y no funciona correctamente',
];

export const transfers: string[] = [
  'ON_ROAD',
  'INDIVIDUAL_TOW_TRUCK',
  'COLLECTIVE_TOW_TRUCK',
];

export const providersFix: CommonSelectorV2[] = [
  {
    id: '021d23ca-ab6a-47f8-a5bf-c39d3c6156af',
    name: 'Cafler fixed Refueling location',
  },
  {
    id: '7b5ee389-9b8f-4316-9a09-25edff0c67c0',
    name: 'Cafler fixed Pre-ITV',
  },
  {
    id: '78c96389-4fc5-4333-b1aa-30e6777363c9',
    name: 'Cafler fixed Maintenance location',
  },
];

export const vehicleChassisType: VehicleChassisType[] = [
  {
    value: 1,
    name: 'SEDAN',
    real_name: 'Turismo',
  },
  {
    value: 2,
    name: 'MINIVAN',
    real_name: 'Monovolumen',
  },
  {
    value: 3,
    name: 'ATV',
    real_name: 'Todoterreno',
  },
  {
    value: 4,
    name: 'LIGHT_VAN',
    real_name: 'Furgoneta ligera',
  },
  {
    value: 5,
    name: 'VAN',
    real_name: 'Furgoneta',
  },
  {
    value: 6,
    name: 'BOX_TRUCK',
    real_name: 'Furgón',
  },
  {
    value: 20,
    name: 'SCOOTER',
    real_name: 'Moto (hasta 125cc)',
  },
  {
    value: 21,
    name: 'MOTORBIKE',
    real_name: 'Moto +125cc',
  },
];


export const vehicleChassisTypeTranslated: VehicleChassisType[] = [
  {
    value: 1,
    name: 'SEDAN',
    real_name: 'sedan',
  },
  {
    value: 2,
    name: 'MINIVAN',
    real_name: 'minivan',
  },
  {
    value: 3,
    name: 'ATV',
    real_name: 'atv',
  },
  {
    value: 4,
    name: 'LIGHT_VAN',
    real_name: 'light_van',
  },
  {
    value: 5,
    name: 'VAN',
    real_name: 'van',
  },
  {
    value: 6,
    name: 'BOX_TRUCK',
    real_name: 'box_truck',
  },
  {
    value: 20,
    name: 'SCOOTER',
    real_name: 'scooter',
  },
  {
    value: 21,
    name: 'MOTORBIKE',
    real_name: 'motorbike',
  },
];

export const vehicleChassis: string[] = [
  'Turismo',
  'Monovolumen',
  'Todoterreno',
  'Furgoneta ligera',
  'Furgoneta',
  'Furgón',
  'Moto (hasta 125cc)',
  'Moto +125cc',
];

export const clientsList: string[] = [
  'Linkcar Automoció SL',
  'RNO Bymycar Barcelona',
  'Moto reparación SL',
  'Mastertrac de Automoción SA (1)',
  'AUTOVIVO',
  'Maquina Motors S.A.U Terrassa',
  'Màquina Motors SAU (Barcelona)',
  'Proceran 2016 SL',
  'Anteveni S.L',
  'COVESA MOLLET',
  'Centro Avanzado Reparaciones Car, SLU (Linea Directa)',
  'Vespa Balart SAU (2)',
  'IMECAT, S.A.',
  'RNO Bymycar Barcelona (1)',
  'RNO Bymycar Barcelona (2)',
  'Tesla SL (7)',
  'Masterclas de Automoción SA (3)',
  'OK MOBILITY (Baleares)',
  'Test Cafler Barcelona',
];

export const providersNameAlt: string[] = [
  'Cafler fixed Refueling location',
  'Cafler fixed Pre-ITV',
  'Cafler fixed Maintenance location',
];

export const clientPlanTypes: readonly Plan[] = [
  {
    planType: ClientPlanType.HYBRID_PLAN,
    toUpdate: ClientPlanType.HYBRID_PLAN,
    name: 'comercial.clients.detail_client.plan_hybrid',
  },
  {
    planType: ClientPlanType.PREMIUM_PLAN,
    toUpdate: ClientPlanType.PREMIUM_PLAN,
    name: 'comercial.clients.detail_client.plan_premium',
  },
  {
    planType: ClientPlanType.B2B_PLAN,
    toUpdate: ClientPlanType.B2B_PLAN,
    name: 'comercial.clients.detail_client.plan_b2b',
  },
  {
    planType: ClientPlanType.B2C_PLAN,
    toUpdate: ClientPlanType.B2C_PLAN,
    name: 'comercial.clients.detail_client.plan_b2c',
  },
  {
    planType: ClientPlanType.CUSTOM_PLAN,
    toUpdate: ClientPlanType.CUSTOM_PLAN,
    name: 'comercial.clients.detail_client.plan_custom',
  },
] as const;

export const driverStatus: CommonSelectorV4[] = [
  { name: 'personal.status_active', value: true },
  { name: 'personal.status_inactive', value: false },
];

export const clientStatus: CommonSelectorV4[] = [
  { name: 'personal.status_active', value: true },
  { name: 'personal.status_inactive', value: false },
];

export const operatorTypes: CommonSelectorV4[] = [
  { name: 'personal.operator_internal', value: true },
  { name: 'personal.operator_external', value: false },
];

export const roles: CommonSelectorV3[] = [
  { name: 'personal.role_not_specified', value: 'NOT_SPECIFIED' },
  { name: 'personal.role_regular', value: 'REGULAR' },
  { name: 'personal.role_long_distance', value: 'LONG_DISTANCE' },
  { name: 'personal.role_broom_car', value: 'BROOM_CAR' },
  { name: 'personal.role_mobile_washer', value: 'MOBILE_WASHER' },
  { name: 'personal.role_implant_washer', value: 'IMPLANT_WASHER' },
  { name: 'personal.role_implant_office', value: 'IMPLANT_OFFICE' },
  { name: 'personal.role_mobile_workshop', value: 'MOBILE_WORKSHOP' },
  { name: 'personal.role_dispatch_vehicle', value: 'DISPATCH_CAR' },
];
